
import React, { useState } from 'react'
import logo from "../../assets/authlogo.png"
import { Link, useLocation } from "react-router-dom"
import { Accordion, Card, Button } from "react-bootstrap";
import "./Sidebar.css"
import { useSelector } from 'react-redux';

function Sidebar() {
  const location = useLocation();
  const auth = useSelector((state) => state.auth.userArray);
  const { userArray } = useSelector((state) => state.auth);

  const [openIndex, setOpenIndex] = useState(null);
  const pathParts = location.pathname?.split("/"); // Split path into parts
  const sidebarItems = userArray?.user?.role === "Super Admin" ? [
    { name: "لوحة التحكم", path: "dashboard", activePaths: ["dashboard", "", "dashboard"] },
    { name: "الوجبات ", path: "main-meals", activePaths: ["main-meals", "add-main-meals", "meal"] },
    { name: "المطاعم", path: "resturants", activePaths: ["resturants", "", "add-restueant", "edit-restueant"] },
    { name: "المستفيدين", path: "students", activePaths: ["students", "", "add-student"] },
    { name: "الطلبات", path: "orders", activePaths: ["orders", "edite-meal", "add-meal"] },
        { name: "الملاحظات", path: "notes", activePaths: ["notes"] },
        { name: "الاعدادات", path: "settings", activePaths: ["settings"] },



  ] : userArray?.user?.role === "Trainee" ? [
    { name: "لوحة التحكم", path: "student-dashbord", activePaths: ["student-dashbord", "", "student-dashbord"] },
    { name: "الوجبات ", path: "Meals", activePaths: ["Meals"] },
    { name: "الطلبات", path: "student-meals", activePaths: ["student-meals", "edite-meal", "add-meal"] },
    { name: "الملاحظات", path: "student-notes", activePaths: ["student-notes", "edit-note", "add-student-notes"] },
  ] : []
  const isRouteActive = (activePaths = []) => {
    const currentPath = location.pathname.toLowerCase();
    if (currentPath === "/dashboard" && activePaths.includes("dashboard")) {
      return true;
    }
    return activePaths.some(
      (path) =>
        currentPath === `/dashboard/${path}` ||
        currentPath.startsWith(`/dashboard/${path}/`)
    );
  };






  return (
    <div className="sidebar_container">
      <div className="logo_container">
        <h4 style={{ color: "rgb(6, 95, 70)", fontWeight: "bold" }}>الاكاديمية</h4>
      </div>
      <div className="link_container">
        <ul className="p-0 m-0">
          {sidebarItems && sidebarItems.map((item, index) => {

            const isOpen = openIndex === index; // check if this dropdown is open

            return (
              item.subTabs ? (
                <div className="d-flex flex-column text-white p-2 " key={index}>
                  <Button
                    className="nav_item border-0"
                    onClick={() =>
                      setOpenIndex(isOpen ? null : index) // toggle only this one
                    }
                  >
                    <p className="mb-0 pe-4">{item.name}</p>
                    {isOpen ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                        className="bi bi-chevron-up" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 
                          5.647a.5.5 0 0 1-.708-.708z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                        className="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 
                          .708 0L8 10.293l5.646-5.647a.5.5 
                          0 0 1 .708.708l-6 6a.5.5 0 0 
                          1-.708 0l-6-6a.5.5 0 0 1 
                          0-.708" />
                      </svg>
                    )}
                  </Button>

                  {isOpen && (
                    <Accordion defaultActiveKey="0" className="w-100" style={{}}>
                      <Card className="bg-transparent border-0">
                        <Accordion.Collapse eventKey="0">
                          <div className="d-flex flex-column pe-5">
                            {item.subTabs.map((tabitem, subIndex) => {
                              console.log(tabitem.activePaths, "item.activePaths");

                              return (
                                <div
                                  key={subIndex}
                                  className={isRouteActive(tabitem.activePaths) ? "nav_item active" : "nav_item"}

                                >
                                  <Link
                                    className="text-start border-0 w-100"
                                    to={`/dashboard/${tabitem.path ? tabitem.path : tabitem.name.toLowerCase()
                                      }`}
                                  >
                                    ● {tabitem.name}
                                  </Link>
                                </div>
                              )
                            })}
                          </div>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  )}
                </div>
              ) : item.path === "tarteeb" ? (
                <li
                  key={index}
                  className={isRouteActive(item.activePaths) ? "nav_item active" : "nav_item"}

                >
                  <a href="https://taarteb.com/" target="_blank" rel="noopener noreferrer">
                    <span className="mx-2">{item.name}</span>
                  </a>
                </li>
              ) : (
                <li
                  key={index}
                  className={isRouteActive(item.activePaths) ? "nav_item active" : "nav_item"}

                >
                  <Link to={`/dashboard/${item.path ? item.path : item.name.toLowerCase()}`} className='w-100'>
                    <span className="mx-2 w-100">{item.name}</span>
                  </Link>
                </li>
              )
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
